/* GOWin® Store — puente invisible /cart -> última página + drawer. */
(() => {
  const LAST_KEY = 'gowin:last-storefront-url:v2';
  const OPEN_KEY = 'gowin:open-cart-drawer:v2';
  const config = window.GOWinCartRouteConfig || {};

  const normalizePath = (value) => {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (_) {
      return String(value || '').replace(/\/+$/, '') || '/';
    }
  };

  const cartPath = normalizePath(config.cartUrl || '/cart');
  const current = new URL(window.location.href);

  const isAllowedStorefrontUrl = (url) => {
    if (!url || url.origin !== window.location.origin) return false;

    const path = normalizePath(url.pathname);
    if (path === cartPath) return false;
    if (path.startsWith('/checkout') || path.startsWith('/checkouts')) return false;

    return true;
  };

  const preservePreviewParams = (target) => {
    ['preview_theme_id', 'preview_key'].forEach((key) => {
      const value = current.searchParams.get(key);
      if (value && !target.searchParams.has(key)) {
        target.searchParams.set(key, value);
      }
    });
  };

  const releasePending = () => {
    document.documentElement.classList.remove('gowin-cart-route-pending');
  };

  const openDrawer = () => {
    let attempts = 0;

    const tryOpen = () => {
      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.open === 'function') {
        if (!drawer.classList.contains('active')) {
          const trigger = document.querySelector('#cart-icon-bubble');
          window.requestAnimationFrame(() => drawer.open(trigger || undefined));
        }
        return;
      }

      attempts += 1;
      if (attempts < 40) window.setTimeout(tryOpen, 50);
    };

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer').then(tryOpen).catch(tryOpen);
    } else {
      tryOpen();
    }
  };

  const onCartRoute = normalizePath(current.pathname) === cartPath;

  if (onCartRoute) {
    let target = null;

    try {
      const stored = window.sessionStorage.getItem(LAST_KEY);
      if (stored) {
        const parsed = new URL(stored, window.location.origin);
        if (isAllowedStorefrontUrl(parsed)) target = parsed;
      }
    } catch (_) {}

    if (!target) {
      target = new URL(config.rootUrl || '/', window.location.origin);
    }

    preservePreviewParams(target);

    try {
      window.sessionStorage.setItem(OPEN_KEY, '1');
    } catch (_) {}

    if (target.href !== current.href) {
      window.location.replace(target.href);

      window.setTimeout(() => {
        releasePending();
        openDrawer();
      }, 1600);

      return;
    }

    releasePending();
    openDrawer();
    return;
  }

  releasePending();

  if (isAllowedStorefrontUrl(current)) {
    try {
      window.sessionStorage.setItem(LAST_KEY, current.href);
    } catch (_) {}
  }

  let shouldOpen = false;

  try {
    shouldOpen = window.sessionStorage.getItem(OPEN_KEY) === '1';
    if (shouldOpen) window.sessionStorage.removeItem(OPEN_KEY);
  } catch (_) {}

  if (shouldOpen) openDrawer();
})();
